/* eslint-disable */
import React, {useState, useEffect, createContext} from "react";
import './App1.css'
import RightMenu from 'views/RightMenu/index'
import BottomMenu from 'views/BottomMenu/index'
import {getSearchString} from "./js/common/utils";
import {Interface3D} from "./3dlibs2/Interface3D";
import axios from "axios";
import {Progress, message} from "antd";

export const ThemeContext = React.createContext({});

const base = window.base;

// axios.headers.Au

function App1() {
  const [messageApi, contextHolder] = message.useMessage()

  let [progressValue, setProgressValue] = useState(0);
  let [modelProgress, setModelProgress] = useState(0)
  let [editor, setEditor] = useState(null);
  let [id, setId] = useState(null); //id用于服务器模型加载
  let [webJson, setWebJson] = useState(null);
  let [loading, setLoading] = useState(true);
  let [initLoading, setInitLoading] = useState(true);


  useEffect(() => {
    let pathname = window.location.pathname; //根据窗口的输入输入特定得内容

    if (pathname) {
      let location = window.location;

      if (location) {
        let search = location.search;

        if (search) {
          let model = getSearchString("model", search);
          let token = getSearchString("token", search)

          if (token) {
            sessionStorage.setItem('token', token)
            const origin = location.origin
            window.location.href = `${origin}?model=${model}`
          } else {
            token = sessionStorage.getItem('token')

            if (!token) {
              messageApi.open({type: 'error', content: '请登录后使用'})
              return
            }
          }
          setId(model)
        }
      }
    }
  }, [messageApi]);

  useEffect(() => {
    if (id) {
      getProjectInfo(id)
      getUserInfo()
    }
  }, [id])

  useEffect(() => {
    /*进度条*/
    if (editor) {
      editor.setUpdateProgressCb((value) => {
        setProgressValue(Number(value));
      });
      editor.setLoadModellibProgressCB((value) => {
        setModelProgress(Number(value))
      })
    }
  }, [editor, progressValue, modelProgress])

  /**
   * 获取学生上传作业项目信息
   * */
  let getProjectInfo = async function (id) {
    setLoading(true);

    let data;
    if (id) {
      data = await getMode(id);
      let options = new Object();
      options.modelInfo = [];
      options.assetid = data._id;
      let modelurl = `${base}/${data.model}`;
      let configUrl = `${base}/${data.configUrl}`;

      options.modelInfo.push({
        description: data.description,
        id: data._id,
        mapRatio: data.mapRatio,
        dataId: data._id,
        name: data.name,
        path: modelurl,
        // path: 'http://127.0.0.1:3000/public/model/6537a6de93340a19ec4a679e/model/6537a6de93340a19ec4a679e.gltf',
        modelurl: modelurl,
        // modelurl: 'http://127.0.0.1:3000/public/model/6537a6de93340a19ec4a679e/model/6537a6de93340a19ec4a679e.gltf',
        configurl: configUrl,
        texturesurl: [],
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
      });

      options.sceneconfigure = {
        id: 18 /*  */,
        assetid: 72,
        currentbackground: "color",
        backgroundImage: null,
        bgColor1: "#e5d0e7",
        bgColor2: "#353535",
        envMap: 1,
        envMapIntensity: 0.5,
        environment: 0,
        position: "0_0_0",
        scale: "1_1_1",
        rotation: "0_0_0",
        cameraPosition: "0_0_0",
        cameratartget: "0_0_0",
      };

      let modelData = [
        {
          baseModelUrl: modelurl,
          configUrl: configUrl,
          cutPituce: `${base}/${data.screenshot}`,
          description: data.description,
          idmodel: data._id,
          modelUrl: modelurl,
          modelsName: data.name,
          name: data.name,
          _id: data._id,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt,
        },
      ];
      setWebJson(options);
      let mode = 0; //这是编辑模式
      //console.log( "输入的模型的信息",options)
      console.log("模型输入的", process);
      console.log("-*-*-*-*-*-*-*--*==", options, mode, modelData);
      editor = new Interface3D("canvasContainer", options);
      setEditor(editor);
      setInitLoading(true)

      // $("#one").hide();
    }
  };

  /**
   * 获取模型信息
   * */
  async function getMode(id) {
    return new Promise(async (resolve, reject) => {
      await axios.get(base + "/drawing/getOne?_id=" + id)
        .then(res => {
          console.log(res.data);
          resolve(res.data.data);
        }).catch(e => {
          reject(e)
        });
    })
  };

  /**
   * 获取用户信息
   * */
  async function getUserInfo() {
    const token = sessionStorage.getItem('token')
    await axios.get(base + '/student/getInfo', {headers: {Authorization: `Bearer ${token}`}}).then(res => {
      console.log(res.data)
      const userInfo = res.data.data
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    }).catch(e => {
      console.log('getUserInfo--', e)
    })
  }

  return (<div className="app-wrapper">
    {contextHolder}
    {editor ? (
      progressValue === 100 ? (
        <ThemeContext.Provider
          value={{
            webJson: webJson,
            editor: editor,
          }}
        >
          <RightMenu/>
          <BottomMenu/>
        </ThemeContext.Provider>
      ) : null
    ) : !editor && loading && !initLoading ? (
      <div className="errorpage">
        <div className="errorpage-content">
          <span className="iconfont iconcry1 error-icon"></span>
          <div className="error-text">未查询到相关的资源!!!</div>
          <div className="error-text">请填写正确的资源ID!!!</div>
        </div>
      </div>
    ) : null}

    <div
      className="canvas-wrapper"
      id="canvasContainer"
      onDragEnter={(e) => {
        e.preventDefault();
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDragLeave={(e) => {
        e.preventDefault();
      }}
    ></div>
    {/*图纸模型项目加载进度*/}
    {
      editor ? (progressValue === 100) ? null : (
        <div className="model-loading">
          <div className="model-common-loading">
            <Progress
              strokeColor={{
                from: "#108ee9",
                to: "#87d068",
              }}
              percent={progressValue}
              status="active"
            />
          </div>
        </div>
      ) : null
    }
    {/*模型库模型加载进度*/}
    {editor ? (
      modelProgress === 100 || modelProgress === 0 ? null : (
        <div className="model-loading">
          <div className="model-common-loading">
            <Progress
              strokeColor={{
                from: "#108ee9",
                to: "#87d068",
              }}
              percent={modelProgress}
              status="active"
            />
          </div>
        </div>
      )
    ) : null}

    {/*<RightMenu type={rightMenuType} setType={(type) => handleSetRightMenuType(type)}></RightMenu>*/}
    {/*<BottomMenu rightMenuType={rightMenuType}></BottomMenu>*/}
  </div>)
}

export default App1

